
import googleOneTap from 'google-one-tap'
// import axios from 'axios'
export default {
  // watch: {
  //   '$store.state.contentcookie' (newVal) {
  //     if (newVal) {
  //       console.log('newVal: ', newVal)
  //       this.$emit('googlefalse')
  //     }
  //   }
  // },
  mounted() {
    /* this.$store.state.myCountry != 'cn' */
    // eslint-disable-next-line no-constant-condition
    const userAgent = navigator.userAgent
    if (this.$store.state.myCountry != 'cn') {
      // 用户登录
      const DJkdikKMG = this.$cookies.get('DJkdikKMG')
      const ViLartidlakd = this.$cookies.get('ViLartidlakd')
      const WsdsfgDGdagYms = this.$cookies.get('WsdsfgDGdagYms')
      const VEST = this.$cookies.get('VEST')
      const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms || VEST
      // eslint-disable-next-line multiline-ternary
      if (contentcookie || !userAgent.includes('Chrome') || this.$store.state.mobile) return
      const options = {
        client_id: '720725194691-5mlhk8dgsc12gg9409g8bthqhhras28p.apps.googleusercontent.com', // required
        auto_select: false, // optional
        cancel_on_tap_outside: false, // optional
        context: 'signin' // optional
      }
      googleOneTap(options, (response) => {
        // Send response to server
        this.$api.usercenter
          .getWaistcoat(
            {
              Token: response.credential
            },
            {
              HttpMethod: 'post',
              Route: 'usercenter/web/googlecallback'
            }
          )
          .then((res) => {
            this.googleLogin(res)
          })
      })
    }
  },
  methods: {
    googleLogin(res) {
      // 判断是否注册
      if (res.isRegister) {
        this.$nextTick(() => {
          this.setCookie(res.cookieValue)
        })
      } else {
        setTimeout(() => {
          if (process.client) {
            const href = window.location.href.substr(0, window.location.href.indexOf('?')) ? window.location.href.substr(0, window.location.href.indexOf('?')) : window.location.href
            const ulr = `?type=register&id=${res.id}&name=${res.nickName}&img=${res.img}&logintype=${res.loginType}&email=${res.email ? res.email : null}&returnurl=${href}`
            // console.log('`https:', `https://${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
            window.location.href = `//${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`
          }
        }, 500)
      }
    },
    setCookie(cookievalue) {
      // 存cookie
      if (cookievalue) {
        this.$api.home.clientgetUsercookie({ contentcookie: cookievalue }).then((res) => {
          // 主账号信息
          this.$store.commit('setUser', {
            userId: res.result.userId,
            nick: res.result.nick,
            avatar: res.result.avatar,
            vest: false // 是否为马甲号
          })
          console.log('res:切回主账号信息 ', res)
        })
      }
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', cookievalue)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: cookievalue
        }
        window.parent.postMessage(postdata, '*')
      }
      this.$store.commit('setUsercookie', cookievalue)
      this.$store.commit('loginClose', false)
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
